import { Label } from "reactstrap";
import Select, { components } from "react-select";
import { useEffect, useMemo, useState } from "react";
import { REGIONS_URL } from "../../helpers/url_api_helper";

const normalizeRegionsItems = (items) =>
	items.map((item) => ({
		value: item.id,
		label: item.name,
	}));
const RegionSelect = ({ value, onChange, editable }) => {
  const [regions, setRegions] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const CustomClear = (props) => (
    <components.ClearIndicator {...props}>
      <i
        className="fas fa-times"
        style={{ fontSize: "14px", color: "#888" }}
      />
    </components.ClearIndicator>
  );

	const customStyles = {
    singleValue: (base) => ({
      ...base,
      color: editable === true ? "#0576B960" : "#0576B9",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9599AD",
      fontWeight: "400",
    }),
    control: (base, state) => ({
      ...base,
      backgroundColor: state.hasValue ? "#EFF2F7" : "#FFF",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };  

  useEffect(() => {
    let isMounted = true;

    const fetchRegions = async () => {
      setLoading(true);
      setError("");

      try {
        const regionsData = await REGIONS_URL.getRegionAll();
        if (isMounted) {
          setRegions(normalizeRegionsItems(regionsData));
        }
      } catch (error) {
        if (isMounted) {
          setError("Error fetching regions");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchRegions();
    return () => {
      isMounted = false;
    };
  }, []);

  const selectedValue = useMemo(() => {
    if (!value) return null;

    return regions.find(
      (region) => region.value === value.value
    ) || null;
  }, [value, regions]);

  return (
    <>
      <Label className="label-filter">Region</Label>

      <Select
        className="filter-select"
        components={{ ClearIndicator: CustomClear }}
        options={regions}
        value={selectedValue}
        onChange={onChange}
        placeholder={loading ? "Loading..." : "Select Region"}
        isClearable
        styles={customStyles}
        isDisabled={loading || editable}
        menuPortalTarget={document.body}
      />

      {error && <small className="text-danger">{error}</small>}
    </>
  );
};

export default RegionSelect;
